import { useCallback, useEffect } from 'react'

import { useHeaderStore } from '@/store/header.store'

const THRESHOLD = 80

export function useScrollTitle(title: string) {
  const setTitle = useHeaderStore((s) => s.setTitle)
  const setScrolled = useHeaderStore((s) => s.setScrolled)

  useEffect(() => {
    setTitle(title)
    setScrolled(false)
    return () => {
      setTitle('')
      setScrolled(false)
    }
  }, [title, setTitle, setScrolled])

  const onScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      setScrolled(e.currentTarget.scrollTop > THRESHOLD)
    },
    [setScrolled],
  )

  return { onScroll }
}

export function useHeaderSubtitle(subtitle: string | undefined) {
  const setSubtitle = useHeaderStore((s) => s.setSubtitle)
  useEffect(() => {
    setSubtitle(subtitle ?? '')
    return () => setSubtitle('')
  }, [subtitle, setSubtitle])
}
